import styles from './index.less';

const Pagination = ({
  current,
  nextPage,
  nextUrl,
  preUrl,
}: any) => {

  return (
    <div className={styles.pagination}>
      {/* // 分页 */}
      {current > 1 && (
        <a
          data-a-href={preUrl}
          className={styles.prev}
          onClick={() => {
            window.location.href = window.location.origin + preUrl;
          }}
        >
          上一页
        </a>
      )}
      {nextPage && (
        <a
          data-a-href={nextUrl}
          className={styles.next}
          onClick={() => {
            window.location.href = window.location.origin + nextUrl;
          }}
        >
          下一页
        </a>
      )}
    </div>
  )
}
export default Pagination